import { render, staticRenderFns } from "./NvHeader.vue?vue&type=template&id=42e1770b&scoped=true&"
import script from "./NvHeader.vue?vue&type=script&lang=js&"
export * from "./NvHeader.vue?vue&type=script&lang=js&"
import style0 from "./NvHeader.vue?vue&type=style&index=0&id=42e1770b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e1770b",
  null
  
)

export default component.exports